/**
 * Ein Bild, mehrere Auflösungen.
 *
 * Hochgeladen wird derselbe Ausschnitt dreimal:
 *
 *   klein     die Größe, in der das Bild in Listen und Karten steht. Das ist
 *             die Adresse, die im Datensatz landet.
 *   groß      derselbe Ausschnitt in hoher Auflösung, für die Großansicht im
 *             Modal. Ein auf 400 Pixel gerechnetes Bild sieht dort weich aus,
 *             ein 1200er in der Liste wäre Verschwendung.
 *   original  das, was der Vermieter hochgeladen hat (auf 2000 Pixel
 *             begrenzt). Wird nirgends angezeigt — es liegt da, damit sich
 *             derselbe Ausschnitt später neu wählen lässt, ohne dass er noch
 *             einmal vom Handy geholt werden muss.
 *
 * Gespeichert wird nur die kleine Adresse. Die anderen ergeben sich aus ihr
 * über die Endung — das spart eine Schemaänderung an jeder Stelle, an der
 * heute ein Bild hängt (Logo, Fotobox, Extra).
 */

const ENDUNGEN = { gross: "-gross", original: "-original" };

/**
 * Macht aus der gespeicherten Adresse die einer anderen Auflösung.
 *
 * Robust gegen den Zeitstempel, der beim Hochladen angehängt wird
 * (…/extras/extra_0007.webp?v=1724300000000) — er muss erhalten bleiben,
 * sonst zeigen Browser und CDN nach dem Ersetzen weiter das alte Bild.
 *
 * Gibt es keine große Fassung — alle vor dem 2026-08-22 hochgeladenen Bilder
 * haben keine —, liefert die Funktion die Ausgangsadresse zurück. Lieber ein
 * etwas weiches Bild als ein fehlendes.
 */
export function bildVariante(url, variante) {
  const zusatz = ENDUNGEN[variante];
  if (!url || !zusatz) return url || "";

  const [pfad, frage] = String(url).split("?");
  const punkt = pfad.lastIndexOf(".");
  // Kein Punkt im letzten Pfadstück? Dann gibt es keine Endung, an die sich
  // etwas anhängen ließe.
  if (punkt < 0 || punkt < pfad.lastIndexOf("/")) return url;

  const neu = `${pfad.slice(0, punkt)}${zusatz}${pfad.slice(punkt)}`;
  return frage ? `${neu}?${frage}` : neu;
}

/** Die Adresse für die Großansicht. */
export const grossesBild = (url) => bildVariante(url, "gross");
